import { CPTAdultCustomDefaultConfig } from "@constants/testConstants/testSpecificConstants/cptCustomCalibrations";
import { cptInstruction } from "@constants/instructionConstants";
import { virtualAssistanceCPTAdultGoNoGoConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  CPTConfigMode,
  TestConfiguration,
  TestCategory,
  EyeType,
  CPTCustomConfiguration,
  Stimulus,
  StimulusType,
  StimulusPosition,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";

import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  CALIBRATION_TOGGLE_OPTION_NEW_APK,
  DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
} from "../configurationHelperConstants";

export const availableCPTConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.ContinuousPerformance],
    isMandatory: true,
    choices: [
      { validSinceVersion: TEST_TYPE_VERSION_MAP["GoNoGo"], value: TestType.GoNoGo },
      {
        validSinceVersion: TEST_TYPE_VERSION_MAP["IdenticalPairs"],
        value: TestType.IdenticalPairs,
      },
    ],
  },
  eyeConfigurationOptions: {
    ...AVAILABLE_EYE_OPTIONS_BINOCULAR,
    toggleCalibrationOption: { ...CALIBRATION_TOGGLE_OPTION_NEW_APK },
  },
  languageOptions: null,
  virtualAssistantOptions: AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  testSpeedOptions: null,
  testSpecificConfigurationOptions: {
    ...DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
    cptConfigModes: {
      validSinceVersion: null,
      choices: [
        {
          validSinceVersion: null,
          value: CPTConfigMode.Default,
        },
        {
          validSinceVersion: null,
          value: CPTConfigMode.Demo,
        },
        {
          validSinceVersion: null,
          value: CPTConfigMode.Adult,
        },
        {
          validSinceVersion: null,
          value: CPTConfigMode.AdultDemo,
        },
      ],
      configurationFieldName: "cptConfigMode",
    },
  },
};

export const cptConfiguration: TestConfiguration = {
  name: TestCategory.ContinuousPerformance,
  testType: TestType.GoNoGo,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceCPTAdultGoNoGoConfig,
  isPressToStartEnabled: true,
  extraData: {
    ...CPTAdultCustomDefaultConfig,
    cptConfigMode: CPTConfigMode.Adult,
  } as CPTCustomConfiguration,
};

export const cptUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: cptInstruction,
};

export const cptStimuliListForResultsPage: Stimulus[] = [
  {
    id: "target_01",
    imageName: "image_generic_target",
    position: null,
    timeStamp: 0,
    type: StimulusType.Target,
  },
  {
    id: "distractor_01",
    imageName: "image_generic_visual_distractor",
    position: StimulusPosition.Left,
    timeStamp: 0,
    type: StimulusType.VisualDistractor,
  },
  {
    id: "distractor_02",
    imageName: "image_generic_visual_distractor",
    position: StimulusPosition.Right,
    timeStamp: 0,
    type: StimulusType.VisualDistractor,
  },
  {
    id: "distractor_03",
    imageName: "image_generic_visual_distractor",
    position: StimulusPosition.Top,
    timeStamp: 0,
    type: StimulusType.VisualDistractor,
  },
];
